// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Inter-Thin.woff2?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("Inter-Thin.woff?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("Inter-ExtraLight.woff2?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("Inter-ExtraLight.woff?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("Inter-Light.woff2?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("Inter-Light.woff?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("Inter-Regular.woff2?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("Inter-Regular.woff?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("Inter-Medium.woff2?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("Inter-Medium.woff?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("Inter-SemiBold.woff2?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("Inter-SemiBold.woff?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("Inter-Bold.woff2?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("Inter-Bold.woff?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("Inter-ExtraBold.woff2?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("Inter-ExtraBold.woff?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("Inter-Black.woff2?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("Inter-Black.woff?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("Inter-roman.var.woff2?v=3.18", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("Inter-italic.var.woff2?v=3.18", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 100;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 200;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 300;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 400;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 500;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 600;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 700;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 800;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff");
}
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 900;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2"),
       url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff");
}
/* -------------------------------------------------------
Variable font.
Usage:

  html { font-family: 'Inter', sans-serif; }
  @supports (font-variation-settings: normal) {
    html { font-family: 'Inter var', sans-serif; }
  }
*/
@font-face {
  font-family: 'Inter var';
  font-weight: 100 900;
  font-display: auto;
  font-style: normal;
  font-named-instance: 'Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2");
}
@font-face {
  font-family: 'Inter var';
  font-weight: 100 900;
  font-display: auto;
  font-style: italic;
  font-named-instance: 'Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff2");
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/inter/inter.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB;6DACiD;AACnD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB;6DACuD;AACzD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB;6DACkD;AACpD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB;6DACoD;AACtD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB;6DACmD;AACrD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB;8DACqD;AACvD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB;8DACiD;AACnD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB;8DACsD;AACxD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB;8DACkD;AACpD;AACA;;;;;;;;CAQC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,6DAAwD;AAC1D;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,6DAAyD;AAC3D","sourcesContent":["@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 100;\n  font-display: auto;\n  src: url(\"Inter-Thin.woff2?v=3.18\") format(\"woff2\"),\n       url(\"Inter-Thin.woff?v=3.18\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 200;\n  font-display: auto;\n  src: url(\"Inter-ExtraLight.woff2?v=3.18\") format(\"woff2\"),\n       url(\"Inter-ExtraLight.woff?v=3.18\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 300;\n  font-display: auto;\n  src: url(\"Inter-Light.woff2?v=3.18\") format(\"woff2\"),\n       url(\"Inter-Light.woff?v=3.18\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 400;\n  font-display: auto;\n  src: url(\"Inter-Regular.woff2?v=3.18\") format(\"woff2\"),\n       url(\"Inter-Regular.woff?v=3.18\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 500;\n  font-display: auto;\n  src: url(\"Inter-Medium.woff2?v=3.18\") format(\"woff2\"),\n       url(\"Inter-Medium.woff?v=3.18\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 600;\n  font-display: auto;\n  src: url(\"Inter-SemiBold.woff2?v=3.18\") format(\"woff2\"),\n       url(\"Inter-SemiBold.woff?v=3.18\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 700;\n  font-display: auto;\n  src: url(\"Inter-Bold.woff2?v=3.18\") format(\"woff2\"),\n       url(\"Inter-Bold.woff?v=3.18\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 800;\n  font-display: auto;\n  src: url(\"Inter-ExtraBold.woff2?v=3.18\") format(\"woff2\"),\n       url(\"Inter-ExtraBold.woff?v=3.18\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Inter';\n  font-style:  normal;\n  font-weight: 900;\n  font-display: auto;\n  src: url(\"Inter-Black.woff2?v=3.18\") format(\"woff2\"),\n       url(\"Inter-Black.woff?v=3.18\") format(\"woff\");\n}\n/* -------------------------------------------------------\nVariable font.\nUsage:\n\n  html { font-family: 'Inter', sans-serif; }\n  @supports (font-variation-settings: normal) {\n    html { font-family: 'Inter var', sans-serif; }\n  }\n*/\n@font-face {\n  font-family: 'Inter var';\n  font-weight: 100 900;\n  font-display: auto;\n  font-style: normal;\n  font-named-instance: 'Regular';\n  src: url(\"Inter-roman.var.woff2?v=3.18\") format(\"woff2\");\n}\n@font-face {\n  font-family: 'Inter var';\n  font-weight: 100 900;\n  font-display: auto;\n  font-style: italic;\n  font-named-instance: 'Italic';\n  src: url(\"Inter-italic.var.woff2?v=3.18\") format(\"woff2\");\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
